import * as React from 'react';
import {
    MyQuotationDetailsHead,
    MyQuotationLine,
} from '../../../models/quotations/MyQuotation';
import { Box } from '@mui/material';
import { GeneralTable } from '../Table/GeneralTable';
import { MyQuotationProductsRow } from './MyQuotationProductsRow';
import { quotationDetailsProductTableHead } from '../../../utils/constans/tableHeads/quotationDetailsProductTableHead';
import { styled } from '@mui/material/styles';
import { MyQuotationProductsSummary } from './MyQuotationProductsSummary';

const StyledBoxWrapper = styled(Box)(() => ({
    padding: '15px',
    border: '1px solid #ececec',
    backgroundColor: 'white',
}));

export const MyQuotationProducts: React.FC<{ lines: MyQuotationLine[] }> = (
    props
) => {
    const { lines } = props;
    const tableHeadSettings = {
        translateNs: 'quotations',
        translatePrefix: 'QUOTATION_DETAILS.PRODUCTS_TABLE_HEAD',
        selectable: false,
        headContent: quotationDetailsProductTableHead,
    };

    return (
        <>
            <StyledBoxWrapper>
                <Box>
                    <GeneralTable<MyQuotationLine, MyQuotationDetailsHead>
                        fullList={lines}
                        rowComponent={MyQuotationProductsRow}
                        defaultOrderBy={'quoteId'}
                        defaultOrder={'desc'}
                        tableHeadSettings={tableHeadSettings}
                    />
                </Box>
                <Box>
                    <MyQuotationProductsSummary lines={lines} />
                </Box>
            </StyledBoxWrapper>
        </>
    );
};
